/**
 * SIDC MMS Core
 * Our Endpoints are powered by .Net Core, Onion Architecture, CQRS with MediatR Library,Entity Framework Core - Code First,Repository Pattern - Generic, Swagger UI, API Versioning,Fluent Validation and Automapper.
 *
 * OpenAPI spec version: v1
 * Contact: sidcmisdepartment@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface JoinAccountHolder { 
    birthday?: Date;
    id?: number;
    age?: number;
    fileContent?: string;
    fileType?: string;
    presigned?: string;
    officeTelephoneNumber?: string;
    officeAddress?: string;
    sidcCode?: string;
    homeAddress?: string;
    landline?: string;
    mobile?: string;
    firstName?: string;
    lastName?: string;
    middleName?: string;
}